module.exports = __webpack_public_path__ + "static/media/export.9c8757c7.svg";